var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRostoTriste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289:571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.546 15.518C69.858 -5.172 36.199 -5.172 15.515 15.513C-5.173 36.198 -5.171 69.858 15.517 90.547C36.199 111.231 69.858 111.231 90.544 90.543C111.23 69.858 111.229 36.2 90.546 15.518ZM84.757 84.758C67.263 102.252 38.797 102.254 21.302 84.76C3.804 67.263 3.806 38.794 21.302 21.3C38.796 3.807 67.261 3.805 84.759 21.302C102.253 38.796 102.251 67.265 84.757 84.758ZM77.017 74.001C77.675 75.522 76.975 77.287 75.455 77.944C73.934 78.604 72.169 77.902 71.511 76.382C68.618 69.693 61.781 65.37 54.09 65.37C46.222 65.37 39.343 69.689 36.568 76.374C36.089 77.528 34.972 78.225 33.797 78.225C33.413 78.225 33.024 78.151 32.647 77.995C31.117 77.359 30.392 75.603 31.027 74.074C34.737 65.142 43.791 59.371 54.09 59.371C64.174 59.371 73.174 65.113 77.017 74.001ZM33.24 38.671C33.24 35.247 36.017 32.47 39.441 32.47C42.864 32.47 45.641 35.246 45.641 38.671C45.641 42.097 42.864 44.873 39.441 44.873C36.017 44.873 33.24 42.097 33.24 38.671ZM61.357 38.671C61.357 35.247 64.136 32.47 67.56 32.47C70.983 32.47 73.76 35.246 73.76 38.671C73.76 42.097 70.984 44.873 67.56 44.873C64.136 44.873 61.357 42.097 61.357 38.671Z",
    fill: "#A8100A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289:571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.059,
    height: 106.059,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRostoTriste);
export default __webpack_public_path__ + "static/media/rosto-triste.2ce61ae10b346edd5fcbafe2bbceba54.svg";
export { ForwardRef as ReactComponent };